import BaseChangeset from 'common/changesets/base';

export type ContactDTO = {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
};

export class ContactChangeset extends BaseChangeset<ContactDTO> {}
